import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
const MonitoringSelector = ({
  projectId,
  versionId,
  projectLastVersion,
  isInDashboard = false,
  state,
  setState,
}) => {
  const history = useHistory();
  const [selectedMonitoringVersion, setSelectedMonitoringVersion] = useState(null);
  useEffect(() => {
    if (isInDashboard) {
      setSelectedMonitoringVersion(state);
      return;
    }
    if (!isInDashboard && versionId >= 0) {
      setSelectedMonitoringVersion(versionId);
      return;
    }
  }, [versionId, selectedMonitoringVersion, isInDashboard, state]);

  const n = useMemo(() => {
    const v = Number(projectLastVersion);
    return Number.isFinite(v) && v >= 0 ? v : 0;
  }, [projectLastVersion]);

  // Crea le opzioni 1..n
  const options = useMemo(() => {
    return Array.from({ length: n }, (_, i) => ({
      value: String(i + 1),
      label: `Versione ${i + 1}`,
    }));
  }, [n]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
      <label htmlFor='monitoringVersionSelector' style={{ whiteSpace: 'nowrap' }}>
        Versione del Monitoraggio:
      </label>
      <Select
        name='monitoringVersionSelector'
        placeholder='Seleziona...'
        value={{ value: selectedMonitoringVersion, label: `Versione ${selectedMonitoringVersion}` }}
        options={options}
        onChange={(e) => {
          if (isInDashboard) {
            setState(e.value);
            return;
          } else if (+e.value === 0) {
            history.push(`/valutazione/${projectId}`);
          } else {
            history.push(`/monitoraggio/${projectId}/ver=${e.value}`);
          }
        }}
        // isDisabled={isDisabled}
      />
    </div>
  );
};

export default MonitoringSelector;
